import "./DetalleBanner.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Button } from "react-bootstrap";
import { BotonRegresar } from "../../../components/boton-regresar/BotonRegresar";
import { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

import { getComunicado } from "../../../Services/ComunicadosService";

import { BannerRequest } from "../../../interfaces/bannerInterfaces";
import { getBanner, guardarBanner } from "../../../Services/BannersService";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import * as yup from "yup";
import { stringToDate } from "../../../Utilidades/commons";
import { StatusAlertService } from "react-status-alert";
import ReactQuill, { Quill } from "react-quill";
import ImageEdit from "quill-image-edit-module";
import { postAdjunto } from "../../../Services/AdjuntosService";

var Size = Quill.import("attributors/style/size") as any;
Size.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "25px",
  "30px",
  "40px",
  "50px",
];
Quill.register(Size, true);
Quill.register("modules/imageEdit", ImageEdit);
let quill: any = null;

export const DetalleBanner = () => {
  const [bannerId, setBannerId] = useState(0);
  const [descripcion, setDescripcion] = useState('');
  const [titulo, setTitulo] = useState('');
  const [fechaPublicacion, setFechaPublicacion] = useState<Date>(new Date());
  const [fechaCierre, setFechaCierre] = useState<Date>(new Date());
  const [permanente, setPermanente] = useState(false);
  const [severidad, setSeveridad] = useState("Error");
  const [timeInicio, setTimeInicio] = useState("10:00");
  const [timeFin, setTimeFin] = useState("10:00");

  const params = useParams();
  let idComunicado = params.comunicadoId;

  const bannerSchema = yup.object({
    descripcion: yup.string(),
    titulo: yup.string(),
    fechaPublicacion: yup.date().required("Fecha publicacion es requerida"),
    fechaCierre: yup.date().required("Fecha cierre es requerida"),
    severidad: yup.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(bannerSchema),
    defaultValues: {
      descripcion: '',
      titulo: '',
      fechaPublicacion: new Date(),
      fechaCierre: new Date(),
      severidad: "Info",
    },
  });

  const colors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466",
  ];
  const imagenContenidoHandler = async () => {
    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      var file: any = input && input.files ? input.files[0] : null;
      var formData = new FormData();
      formData.append("file", file);
      const quillRef: any = quillEl?.current;
      if (quillRef) {
        quill = quillRef?.getEditor();
        const response: any = await postAdjunto(formData).catch(
          ({ response }) => {
            const { data } = response;
            StatusAlertService.showError(data.meta.message);
            return false;
          }
        );
        if (response.data) {
          const range = quill.getSelection();
          let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
          quill.insertEmbed(
            range.index,
            "image",
            downloadUri
          );
        }
      }
    };
  };

  const modul = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ font: Font.whitelist }],
          [{ font: [] }],
          [
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            "link",
            "code-block",
            "image",
            { align: [] },
          ],
          [{ size: Size.whitelist }],
          [{ color: colors }, { background: colors }],
          [{ list: "ordered" }, { list: "bullet" }],
        ],
        handlers: {
          image: imagenContenidoHandler,
        },
      },
      imageEdit: {
        modules: ["Resize", "DisplaySize", "Toolbar", "Delete"],
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const navigate = useNavigate();

  const quillEl = useRef(null);

  useEffect(() => {
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
    }

    if (idComunicado !== "0") {
      setBannerId(Number(idComunicado));

      getBanner(Number(idComunicado)).then((response) => {
        if (response.data && response.data.data) {
          console.log("respuestaaa", response.data.data);

          setTitulo(response.data.data.titulo);
          setDescripcion(response.data.data.contenido);
          setPermanente(response.data.data.permanente);
          setSeveridad(response.data.data.severidad);
          setFechaPublicacion(response.data.data.inicio);
          setFechaCierre(response.data.data.fin);
          setTimeInicio(moment(response.data.data.inicio).format("hh:mm"));
          setTimeFin(moment(response.data.data.fin).format("hh:mm"));

          //setValue("titulo", response.data.data.titulo);
          setValue("descripcion", response.data.data.contenido);
          setValue("severidad", response.data.data.severidad);
        }
      });
    }
  }, []);

  const onChangeContenido = (target: any) => {
    const src = target.slice(target.indexOf('src="data:')).split('"')[1];
    if (src) {
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const formData = new FormData();
          const file = new File([blob], "imagen.jpeg");
          formData.append("file", file);
          guardarAdjuntoCopiado(formData, src, target);
        });
    }
    setDescripcion(target);
  };

  const guardar = async () => {

    if (titulo === '') {
      StatusAlertService.showError('Se requiere campo Titulo');
      return;
    }
    if (descripcion === '') {
      StatusAlertService.showError('Se requiere campo Descrición');
      return;
    }

    let banner = {} as BannerRequest;
    banner.id = bannerId;
    banner.titulo = titulo;
    banner.contenido = descripcion;
    banner.inicio =
      moment(fechaPublicacion).format("YYYY-MM-DD") + ` ${timeInicio}:00.00`;
    banner.fin = moment(fechaCierre).format("YYYY-MM-DD") + ` ${timeFin}:00.00`;
    banner.permanente = permanente;
    banner.severidad = getValues("severidad");
    banner.estatus = true;

    guardarBanner(banner)
      .then((result) => {
        reset();
        StatusAlertService.showSuccess("Exito");
        navigate("/banners");
      })
      .catch((error) => console.error(error));
  };

  const assignTimeInicio = (e) => {
    setTimeInicio(e);
  };

  const assignTimeFin = (e) => {
    setTimeFin(e);
  };

  const onSubmit = async (data : any) => {
    console.log("Form Submitted:", data);
    guardar();
  };

  const guardarAdjuntoCopiado = async (
    formData: FormData,
    imagedata: string,
    conte: string
  ) => {
    const response: any = await postAdjunto(formData).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data) {
      let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
      setDescripcion(conte.replace(imagedata, downloadUri));
    }
  };

  return (
    <>
      <Row className="pt-3 mb-2">
        <BotonRegresar></BotonRegresar>
      </Row>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mt-3 agregar-usuario">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">
                {bannerId === 0 ? "Nuevo Banner" : "Editar Banner"}
              </Col>
            </Row>

            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                  <Form.Label>Titulo</Form.Label>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder=""
                      aria-label="Search"
                      value={titulo}
                      maxLength={200}
                      onChange={(e : any) => setTitulo(e.target.value)}
                      className={errors.titulo ? " borde-rojo" : ""}
                    />
                  </Form>
                  
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Descripción</Form.Label>
                <ReactQuill
                  ref={quillEl}
                  theme="snow"
                  placeholder="Escribe contenido popup..."
                  className="editor-class"
                  modules={modul}
                  value={descripcion}
                  onChange={(e : any) => onChangeContenido(e)}
                  //onChange={setContenido}
                />
                <p className="text-danger">{errors.descripcion?.message}</p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de publicación</Form.Label>
                <Form.Control
                  {...register("fechaPublicacion")}
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  min={moment(new Date().toString()).format("YYYY-MM-DD")}
                  value={moment(fechaPublicacion.toString()).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={(e) =>
                    setFechaPublicacion(stringToDate(e.target.value))
                  }
                  className={errors.fechaPublicacion ? " borde-rojo" : ""}
                />
                <p className="text-danger">
                  {errors.fechaPublicacion?.message}
                </p>
                <TimePicker
                  onChange={(e) => {
                    assignTimeInicio(e);
                  }}
                  value={timeInicio}
                  clockIcon={null}
                />
              </Col>
              <Col sm={2}></Col>
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de cierre</Form.Label>
                <Form.Control
                  {...register("fechaCierre")}
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  className={errors.fechaCierre ? " borde-rojo" : ""}
                  min={moment(new Date().toString()).format("YYYY-MM-DD")}
                  value={moment(fechaCierre.toString()).format("YYYY-MM-DD")}
                  onChange={(e) => setFechaCierre(stringToDate(e.target.value))}
                />
                <TimePicker
                  onChange={(e) => {
                    assignTimeFin(e);
                  }}
                  value={timeFin}
                  clockIcon={null}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={6} className="">
                <Row className="d-flex">
                  <Col sm={12} className="mb-4">
                    {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
                    <Row>
                      <Col sm={10} className="mb-2">
                        <Form.Label>Severidad</Form.Label>
                        <Form.Select
                          aria-label="Severidad"
                          {...register("severidad")}
                          onChange={(e) => setSeveridad(e.target.value)}
                          value={severidad}
                        >
                          <option value="danger">Error</option>
                          <option value="info">Info</option>
                          <option value="success">Success</option>
                          <option value="warning">Warning</option>
                        </Form.Select>
                      </Col>
                    </Row>

                    <Row></Row>
                    {/*Modificacion: Marca de Fin WII C-24-1229-24*/}

                    <label>
                      <input
                        className="primary checkrojo"
                        type="checkbox"
                        checked={permanente}
                        onChange={(e) => setPermanente(!permanente)}
                      />
                      Es permanente
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button type="submit" variant="primary" className="float-end">
                {bannerId === 0 ? "Crear Banner" : "Actualizar Banner"}
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};
